import { isCreateOperation } from '../utils/eventHandlerUtil';
import { applyAdjDispositionToOrder, hasAdjDisposition } from '../utils/adjDisposition';

const saveExitBtnClickHandlerUtil = async ({
    t,
    setLockLoader,
    checkIfOrderIsSubmitted,
    myCaseRefId,
    setShowOrderLockedPopup,
    reportUsageFormObj,
    notes,
    usageDetails,
    showReportPayment,
    reportPaymentGridData,
    createReportPaymentSubmissionProductsArr,
    myCaseResourceType,
    getPriceInNumberDataType,
    discrepencyUpdatedDetails,
    currentActivity,
    storedItemTableData,
    emailInputBoxes,
    setEmailInputBoxes,
    setEmails,
    discrepancyAttachment,
    vendorCaseId,
    dispatch,
    createUsageOrderRequest,
    updateUsageOrderRequest,
    validateEmail,
    orderStatusDescription,
    adjustmentDisEnabled
}) => {
    setLockLoader(true);
    const orderLockedData = await checkIfOrderIsSubmitted('Drafted');
    setLockLoader(false);
    if (orderLockedData?.isOrderLocked) {
        setShowOrderLockedPopup({
            show: true,
            myCaseRef: orderLockedData?.myCaseRef
                ? orderLockedData?.myCaseRef
                : myCaseRefId,
            modifiedBy: orderLockedData?.user,
        });
    } else {
        if (Object.keys(reportUsageFormObj).length > 0) {
            const draftUsageOrderObj = { ...reportUsageFormObj };
            let tempReplenNote = [];
            let tempUsageNote = [];

            let replNote = notes?.reportReplenishmentNotes;
            replNote?.length > 0 &&
                replNote.map((it) => {
                    tempReplenNote.push({
                        creationDate: it.creationDate,
                        note: it.note,
                        typeOfNote: it.typeOfNote,
                        userName: it.userName,
                        statusOfSEOrder: it.statusOfSEOrder
                            ? it.statusOfSEOrder
                            : '',
                    });
                });
            let usageNote = notes?.reportUsageNotes;
            usageNote?.length > 0 &&
                usageNote.map((it) => {
                    tempUsageNote.push({
                        creationDate: it.creationDate,
                        note: it.note,
                        typeOfNote: it.typeOfNote,
                        userName: it.userName,
                        statusOfSEOrder: it.statusOfSEOrder
                            ? it.statusOfSEOrder
                            : '',
                    });
                });
            let tempUsageAdjNote = [];
            let usageAdjNote = notes?.reportUsageAdjNotes;
            usageAdjNote?.length > 0 &&
                usageAdjNote.map((it) => {
                    tempUsageAdjNote.push({
                        creationDate: it.creationDate,
                        note: it.note,
                        typeOfNote: it.typeOfNote,
                        userName: it.userName,
                        statusOfSEOrder: it.statusOfSEOrder
                            ? it.statusOfSEOrder
                            : '',
                    });
                });
            draftUsageOrderObj.usagecustomerNotes = tempUsageNote;
            draftUsageOrderObj.usageReplenishmentcustomerNotes = tempReplenNote;
            draftUsageOrderObj.usageAdjcustomerNotes =
                adjustmentDisEnabled &&
                hasAdjDisposition(reportUsageFormObj?.products)
                    ? tempUsageAdjNote
                    : [];
            draftUsageOrderObj.isAdditionalUsage =
                myCaseResourceType === 'additionalUsage';
            draftUsageOrderObj.isChangeAccount =
                usageDetails?.changeAccountEnabled || false;
            if (usageDetails?.changeAccountEnabled) {
                draftUsageOrderObj.updatedZLBAccount =
                    usageDetails?.accountId || usageDetails?.originalAccountId;
            }

            if (showReportPayment && reportPaymentGridData?.length > 0) {
                const accountOwnedItems =
                    reportUsageFormObj.products?.length > 0
                        ? reportUsageFormObj?.products?.filter(
                              (item) => item.isAccountOwned
                          )
                        : [];

                const reportPaymentProductsArr =
                    createReportPaymentSubmissionProductsArr(
                        [...reportPaymentGridData, ...accountOwnedItems],
                        reportUsageFormObj.products?.length > 0
                            ? reportUsageFormObj?.products
                            : [],
                        myCaseResourceType
                    );
                draftUsageOrderObj.products = reportPaymentProductsArr;
            }
            if (
                myCaseResourceType !== 'reportPayment' &&
                draftUsageOrderObj.products?.length > 0
            ) {
                draftUsageOrderObj.products = draftUsageOrderObj.products.map(
                    (item) => ({
                        ...item,
                        isAdditionalCartEntry: false,
                        unitPrice: item.isAccountOwned
                            ? '0.00'
                            : getPriceInNumberDataType(item.unitPrice)?.toFixed(
                                  2
                              ),
                    })
                );
            }
            if (
                discrepencyUpdatedDetails?.discrepancyExists &&
                currentActivity === 'Submit'
            ) {
                const storedItemProduct = [...storedItemTableData];
                draftUsageOrderObj.products = draftUsageOrderObj.products.map(
                    (item) => {
                        const temp = storedItemProduct.filter(
                            (x) =>
                                x.cfn === item.productCFN &&
                                item.unqId === x.unqId
                        );
                        return {
                            ...item,
                            useMadeAccountOwned:
                                item.isAccountOwned ===
                                temp?.[0]?.userMadeAccountOwned
                                    ? false
                                    : true,
                        };
                    }
                );
                if (emailInputBoxes.length > 0) {
                    const checkNonEmptyEmailLists =
                        emailInputBoxes.length >= 1
                            ? emailInputBoxes.filter((x) => x.value !== '')
                                  ?.length > 0
                                ? true
                                : false
                            : false;

                    emailInputBoxes && emailInputBoxes?.length
                        ? emailInputBoxes.length >= 1 && checkNonEmptyEmailLists
                            ? emailInputBoxes.map((emails) => {
                                  if (emails && emails.value) {
                                      if (!validateEmail(emails.value)) {
                                          emails.errorMessage = t(
                                              'orders.reportsAndInvoice.viewReport.reqinvoice'
                                          );
                                      } else {
                                          emails.errorMessage = '';
                                      }
                                  } else {
                                      emails.errorMessage = '';
                                  }

                                  return { ...emails };
                              })
                            : emailInputBoxes.map((emails, index) => {
                                  if (index === 0) {
                                      if (
                                          checkNonEmptyEmailLists &&
                                          !validateEmail(emails.value)
                                      ) {
                                          emails.errorMessage = t(
                                              'orders.reportsAndInvoice.viewReport.reqinvoice'
                                          );
                                      } else {
                                          emails.errorMessage = '';
                                      }
                                  }

                                  return { ...emails };
                              })
                        : null;

                    setEmailInputBoxes([...emailInputBoxes]);
                    const checkValid =
                        emailInputBoxes.filter((x) => x.errorMessage !== '')
                            .length > 0;

                    const validEmailAddress = emailInputBoxes.filter(
                        (x) => x.value !== '' && x.errorMessage == ''
                    );
                    const emailIdsObj = validEmailAddress?.map((x) => x?.value);
                    if (emailIdsObj?.length > 0) {
                        setEmails(emailIdsObj);
                    }

                    const usageSEDiscrepancy = {
                        discrepancyExists: true,
                        discrepancyDto: {
                            emailIds: emailIdsObj?.toString(),
                            uploadedFileNames: discrepancyAttachment.toString(),
                        },
                    };
                    if (!checkValid && checkNonEmptyEmailLists) {
                        draftUsageOrderObj.vendorCaseId = vendorCaseId;
                        draftUsageOrderObj.usageSEDiscrepancy =
                            usageSEDiscrepancy;
                        draftUsageOrderObj.isSapSubmission = false;
                        const isCreate = isCreateOperation(myCaseResourceType, orderStatusDescription, t);
                        dispatch(
                            isCreate
                                ? createUsageOrderRequest(applyAdjDispositionToOrder(draftUsageOrderObj, adjustmentDisEnabled), 'save&exit')
                                : updateUsageOrderRequest(applyAdjDispositionToOrder(draftUsageOrderObj, adjustmentDisEnabled), 'save&exit')
                        );
                    }
                }
            } else {
                draftUsageOrderObj.isSapSubmission = false;
                const isCreate = isCreateOperation(myCaseResourceType, orderStatusDescription, t);
                dispatch(
                    isCreate
                        ? createUsageOrderRequest(applyAdjDispositionToOrder(draftUsageOrderObj, adjustmentDisEnabled), 'save&exit')
                        : updateUsageOrderRequest(applyAdjDispositionToOrder(draftUsageOrderObj, adjustmentDisEnabled), 'save&exit')
                );
            }
        }
    }
};

export default saveExitBtnClickHandlerUtil;
